export const normalizeFiltersByLabel = filters =>
  filters.reduce((acc, filter) => {
    const filters = acc[filter.metadata.label] || []

    acc[filter.metadata.label] = [...filters, filter]

    return acc
  }, {})
